import axios from 'axios'
import store from '../store';


function get_api(){
    var api = axios.create({
        headers: {
        "Content-Type": "application/json",
        },
    });

    api.interceptors.request.use(
    (config) => {
        window.NProgress.start()
        const token = store.state.access_token || localStorage.getItem("XPAYROLLaccess_token");
        if (token && token !== "undefined" && token !== "null" && token.trim() !== "") {
            config.headers["Authorization"] = 'Bearer ' + token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
    );
    api.interceptors.response.use(

        (res) => {
        window.NProgress.done()
        return res;
        },
        async (err) => {
            window.NProgress.done()
            if (err.response) {
                const isAuthUrl = err.config && err.config.url && (err.config.url.endsWith('/login') || err.config.url.endsWith('/register'));
                if (err.response.status === 401 && !isAuthUrl) {
                    const failedAuthHeader = err.config && err.config.headers && (err.config.headers['Authorization'] || err.config.headers['authorization']);
                    const currentToken = store.state.access_token || localStorage.getItem("XPAYROLLaccess_token");
                    
                    // Only clear storage if the token that failed is actually the one currently stored
                    if (failedAuthHeader === ('Bearer ' + currentToken) || !failedAuthHeader) {
                        console.log("Removing invalid/expired session token")
                        store.commit('set_access_token', "")
                        localStorage.removeItem('XPAYROLLaccess_token')
                        if (window.location.pathname !== '/' && window.location.pathname !== '/login' && window.location.pathname !== '/register') {
                            window.location.href = "/login"
                        }
                    } else {
                        console.warn("Ignoring 401 from stale in-flight request; active session preserved.")
                    }
                }
            }
            else {
                return Promise.reject("Error communicating with server: Server did not respond")
            }
            return Promise.reject(err);
        }
    );
    return api
}
export default get_api;